"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const outcomes = [{
  value: "4 MILIONI",
  label: "Strade e Marciapiedi"
}, {
  value: "2 MILIONI",
  label: "Decoro e Verde"
}, {
  value: "100%",
  label: "FONDI CERTI"
}, {
  value: "2028",
  label: "PIANO BIENNALE"
}];
export default function StrategicOutcomes() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}